module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4BAMAAABaqCYtAAAAAXNSR0IArs4c6QAAAC1QTFRFAAAAAAD/Q3H/QnD/QnL/QXH/Q3H/QnH/Q3H/QnH/RHH/QnH/Q3H/Q3H/Q3H/5BU5DQAAAA50Uk5TAAFfYGDe3t/f7u7v7/5JCiskAAAAbUlEQVQ4y2NgGAUQwHTuHRg0MTD4QFjPFOCSHBCRd28YGPugzAVwST6oyDsGRhjrwqgkHSS5MSUD4JLMdeiSLw1onogEoQBfAkM4CEsCQ/LKaAIbcElOqMhzBsZ9mAks9i4YTGZgMKdbAhsqAABEQg9HkUv2IwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/qita@2x(1).png
// module id = R3l7
// module chunks = 1